import React, { useState, useEffect } from 'react'
import { GridWrapper, ItemsWrapper, GridTitle, ShowMoreCta } from './style'
import EventItem from './EventItem'
import { getTranslations } from '../../../../utils'

const EventsGrid = ({
  id,
  items,
  title,
  isLessThanLaptop,
  language,
  organizationSlug,
  itemsPerRow,
  itemsPerPage,
}) => {
  const [currentIsLessThanLaptop, setIsCurrentIsLessThanLaptop] =
    useState(false)
  const [itemsToShow, setItemsToShow] = useState(0)
  const [gridId, setGridId] = useState(null)

  useEffect(() => {
    if (isLessThanLaptop) setIsCurrentIsLessThanLaptop(isLessThanLaptop)
  }, [isLessThanLaptop])

  useEffect(() => {
    if (id !== gridId) {
      setGridId(id)
      setItemsToShow(itemsPerPage)
    }
  }, [id])

  if (!items?.length) return null

  const getItems = () => {
    const slicedItemsToShow = items.slice(0, itemsToShow)

    let itemsToReturn = slicedItemsToShow?.map((item, i) => {
      return (
        <EventItem
          key={item.url + i}
          isLessThanLaptop={currentIsLessThanLaptop}
          item={item}
          language={language}
          itemsPerRow={itemsPerRow}
        />
      )
    })

    return itemsToReturn
  }

  if (getItems().length) {
    return (
      <>
        <GridWrapper id='grid-wrapper-event'>
          {title ? <GridTitle>{title}</GridTitle> : null}
          <ItemsWrapper>{getItems()}</ItemsWrapper>
          {itemsToShow < items.length ? (
            <ShowMoreCta
              onClick={() => {
                setItemsToShow(itemsToShow + itemsPerPage)
              }}
            >
              {getTranslations('show_more')}
            </ShowMoreCta>
          ) : null}
        </GridWrapper>
      </>
    )
  } else return null
}

export default EventsGrid
